export const getMarketStatRegion = (region: string): string => (region === 'na' ? 'US' : 'EMEA');
